import { Pipe, PipeTransform } from '@angular/core';
import { ProcedureCategoriesCoreService } from '@core/services/features/procedure-categories-core.service';
import { of } from 'rxjs';
import { first, map } from 'rxjs/operators';


@Pipe({
  name: 'procedureCategoryName'
})
export class ProcedureCategoryNamePipe implements PipeTransform {

  constructor(
    private procedureCatCoreSvc: ProcedureCategoriesCoreService
  ) { }

  transform(id?: number | null): any {
    return id ? this.procedureCatCoreSvc.getById(id).pipe(
      first(),
      map(cat => cat.name)
    ) : of('');
  }

}
